export default __webpack_public_path__ + "static/media/term-condition-id.44b007cb.svg";